import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "AddedToCartPopup__content" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", { class: "my-0" }, "Skorzystaj z okazji i dobierz coś ładnego.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-[12px] mb-4 mt-2" }, " Klientki, które kupiły ten produkt, często wybierały też poniższe dodatki. ", -1)
const _hoisted_5 = { class: "AddedToCartPopup__buttons" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 2,
  class: "button-spinner animate-spin h-5 w-5 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

import { computed, ref } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import SliderNavigation from './SliderNavigation.vue';
import { useSelection } from './useSelection';
import { formatPrice } from '../../helpers/formatPrice';
import SingleProductCrossSell from './SingleProductCrossSell.vue';


export default {
  __name: 'ProductCrossSell',
  props: {
    products: Array,
    addProductsToCart: Function,
    processToCart: Function,
},
  setup(__props) {

const props = __props;



const productsData = props.products || [];
const { selectedProducts, isSelected, toggleSelected } = useSelection();

const isLoading = ref(false);

const productSum = computed(() =>
    selectedProducts.value?.reduce((acc, data) => {
        if (data?.variation_id) {
            const price = productsData
                .find((product) => product.id === data.id)
                .variations.find((variation) => variation.id === data.variation_id).raw_price;

            acc += Number(price);

            return acc;
        }

        const product = productsData.find((product) => product.id === data.id);

        acc += Number(product.raw_price);

        return acc;
    }, 0),
);

const finishLoading = () => {
    isLoading.value = false;
};

const onSubmitClick = () => {
    if (selectedProducts.value.length) {
        isLoading.value = true;
        props.addProductsToCart(selectedProducts.value, finishLoading);
    } else {
        props.processToCart();
    }
};

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(SliderNavigation)
      ]),
      _hoisted_4,
      _createVNode(_unref(Swiper), {
        modules: [_unref(Navigation)],
        navigation: {
                prevEl: '.cross-sell-left-arrow',
                nextEl: '.cross-sell-right-arrow',
            },
        "slides-per-view": 'auto',
        "space-between": 8
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productsData), (item) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), {
              key: item.id,
              class: "!w-auto"
            }, {
              default: _withCtx(() => [
                _createVNode(SingleProductCrossSell, {
                  item: item,
                  toggleSelected: _unref(toggleSelected),
                  isSelected: _unref(isSelected)
                }, null, 8, ["item", "toggleSelected", "isSelected"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modules", "navigation"])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        onClick: onSubmitClick,
        class: "Button AddedToCartPopup__continue"
      }, [
        (_unref(productSum) > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(formatPrice)(_unref(productSum))) + " -", 1))
          : _createCommentVNode("", true),
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Przejdź do koszyka"))
          : _createCommentVNode("", true),
        (isLoading.value)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_8, _hoisted_10))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

}